import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

import { remember } from '../return-to-path';

// Where a signed-out visitor's link was going, kept before they are sent to
// sign in: an invitation link opened from the email has to open again once
// they are in, after onboarding if they are new. The root never comes here:
// it is the landing page, so visiting it keeps whatever was remembered.
export function RememberPath() {
  const { pathname } = useLocation();

  useEffect(function() {
    if (pathname.startsWith('/signin') === false) {
      remember(pathname);
    }
  }, [ pathname ]);

  return <Navigate to='/signin' replace/>;
}
